/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Logout_Helper_PlainInputs */

const en_us2_profile_editors_logout_helper_plain = /** @type {(inputs: Profile_Editors_Logout_Helper_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your workouts and answers stay saved.`)
};

const pt_br2_profile_editors_logout_helper_plain = /** @type {(inputs: Profile_Editors_Logout_Helper_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus treinos e respostas continuam salvos.`)
};

const es_419_profile_editors_logout_helper_plain = /** @type {(inputs: Profile_Editors_Logout_Helper_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus entrenamientos y respuestas quedan guardados.`)
};

const pt_pt2_profile_editors_logout_helper_plain = /** @type {(inputs: Profile_Editors_Logout_Helper_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os teus treinos e respostas continuam guardados.`)
};

const fr_fr2_profile_editors_logout_helper_plain = /** @type {(inputs: Profile_Editors_Logout_Helper_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes séances et tes réponses restent enregistrées.`)
};

const de_de2_profile_editors_logout_helper_plain = /** @type {(inputs: Profile_Editors_Logout_Helper_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Trainings und Antworten bleiben gespeichert.`)
};

const it_it2_profile_editors_logout_helper_plain = /** @type {(inputs: Profile_Editors_Logout_Helper_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi allenamenti e le tue risposte restano salvati.`)
};

/**
* | output |
* | --- |
* | "Your workouts and answers stay saved." |
*
* @param {Profile_Editors_Logout_Helper_PlainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_logout_helper_plain = /** @type {((inputs?: Profile_Editors_Logout_Helper_PlainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Logout_Helper_PlainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_logout_helper_plain(inputs)
	if (locale === "es-419") return es_419_profile_editors_logout_helper_plain(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_logout_helper_plain(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_logout_helper_plain(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_logout_helper_plain(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_logout_helper_plain(inputs)
	return en_us2_profile_editors_logout_helper_plain(inputs)
});
export { profile_editors_logout_helper_plain as "profile-editors.logout_helper_plain" }